import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import DataTable from "react-data-table-component";
import axios from "axios";
import { useEffect } from "react";
import { url } from "../../../Constant";
import { useAuth } from "../../../Context/AuthProvider";
import {
  checkIndividualPermission,
  checkPermissions,
} from "../../../Utils/PermissionFunctions";

const CallConferencing = () => {
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState("");
  const [callConferencingData, setCallConferencingData] = useState();
  const [convertedData, setConvertedData] = useState([]);
  const { auth } = useAuth();
  const [loader, setLoader] = useState(false);

  // const handleSearch = (event) => {
  //   setSearchText(event.target.value);
  // };

  const customStyles = {
    pagination: {
      style: {
        display: "flex",
        justifyContent: "space-between",
      },
    },
  };

  const columns = [
    // {
    //   name: "NUMBER",
    //   selector: "number",
    // },
    {
      name: "TO",
      // selector: row => row.members,
      cell: (row) => <div className="table-nowrap">{row.members}</div>,
    },
    {
      name: "SUBJECT",
      selector: (row) => row.subject,
    },
    {
      name: "DURATION",
      selector: (row) => row.duration,
    },
    {
      name: "REMINDER",
      selector: (row) => row.reminder,
    },
    // {
    //   name: "STATUS",
    //   selector: "status",
    // },
    {
      name: "UPDATED",
      selector: (row) => row.updated,
    },
    // {
    //   name: "",
    //   cell: (row) => (
    //     <div className="">
    //       <div className="uk-inline">
    //         <button
    //           className="iconTble actionDropDownBtn"
    //           type="button"
    //           uk-toggle={`target: #drop-menu-${row.id}`}
    //           aria-haspopup="true"
    //           aria-expanded="false"
    //         >
    //           <img
    //             src="./assets/images/zong/overflow-menu--vertical.svg"
    //             uk-svg=""
    //             alt="Menu"
    //           />
    //         </button>

    //         <div
    //           id={`drop-menu-${row.id}`}
    //           uk-dropdown="mode: click"
    //           className="actionDropDown"
    //         >
    //           <ul className="uk-nav uk-dropdown-nav mainauto">
    //             <li>
    //               <a href="#">
    //                 <span>
    //                   <img
    //                     src="./assets/images/zong/download.svg"
    //                     uk-svg=""
    //                     alt="Download"
    //                   />
    //                   <span>Download</span>
    //                 </span>
    //               </a>
    //             </li>
    //             <li>
    //               <a href="#">
    //                 <span className="DeletBtn">
    //                   <img
    //                     src="./assets/images/zong/trash-can.svg"
    //                     uk-svg=""
    //                     alt="Delete"
    //                   />
    //                   <span>Delete</span>
    //                 </span>
    //               </a>
    //             </li>
    //           </ul>
    //         </div>
    //       </div>
    //     </div>
    //   ),
    // },
  ];

  const getCallConferencong = () => {
    setLoader(true);

    let api = "";
    if (auth.role === "2") {
      api = "conference-details";
    } else {
      api = "user-conference-details";
    }

    axios
      .post(
        url + api,
        {
          vpbx_id: auth.vpbx_id,
        },
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      )
      .then(
        (response) => {
          if (response.status === 200) {
            setLoader(false);
            if (
              response.data.message === "Data Not Found" &&
              response.data.data.length === 0
            ) {
              setCallConferencingData([]);
            } else if (response.data.message === "Data Found") {
              setCallConferencingData(response.data.data.details);
            }
          }
        },
        (error) => {
          console.log(error);
          setLoader(false);
        }
      );
  };
  useEffect(() => {
    let membersArray = [];
    let convertedDataConferencing = [];
    if (callConferencingData?.length > 0) {
      callConferencingData?.map((val) => {
        membersArray.push(val.members);
      });
      convertedDataConferencing.push({
        subject: callConferencingData[0].subject,
        duration: `${callConferencingData[0].starttime} - ${callConferencingData[0].endtime}`,
        reminder: "Voice Call",
        updated: callConferencingData[0].starttime,
        members: membersArray.toString(),
      });
      setConvertedData(convertedDataConferencing);
    }
  }, [callConferencingData]);

  useEffect(() => {
    getCallConferencong();
  }, []);

  const filteredDataCallConferencing = convertedData.filter((val) => {
    return (
      // val.members.toLowerCase().includes(searchText.toLowerCase()) ||
      val.reminder.toLowerCase().includes(searchText.toLowerCase()) ||
      val.duration.toLowerCase().includes(searchText.toLowerCase()) ||
      val.updated
        .toLowerCase()
        .includes(searchText.toLowerCase())
        .includes(searchText.toLowerCase()) ||
      val.subject.toLowerCase().includes(searchText.toLowerCase())
    );
  });

  // const handleExportData = () => {
  //   console.log("Exporting data...");
  //   const exportedData = filteredDataCallConferencing.map(
  //     (CallConferencingData) => ({
  //       NUMBER: CallConferencingData.id,
  //       TO: CallConferencingData.callTo,
  //       SUBJECT: CallConferencingData.subject,
  //       DURATION: CallConferencingData.duration,
  //       REMINDER: CallConferencingData.reminder,
  //       STATUS: CallConferencingData.status,
  //       UPDATED: CallConferencingData.updated,
  //     })
  //   );

  //   const csvContent =
  //     "data:text/csv;charset=utf-8," + convertToCSV(exportedData);

  //   const downloadLink = document.createElement("a");
  //   downloadLink.href = csvContent;
  //   downloadLink.download = "exported_data.csv";
  //   downloadLink.click();
  // };

  const convertToCSV = (data) => {
    const header = Object.keys(data[0]).join(",");
    const rows = data.map((item) => Object.values(item).join(","));
    return [header, ...rows].join("\n");
  };

  useEffect(() => {
    if (callConferencingData !== undefined) {
      // Target dynamically generated nav for pagination
      const paginationNav = document.querySelector("nav.rdt_Pagination");
      console.log(paginationNav);
      if (paginationNav) {
        // Select the elements for the left group (first span and first div)
        const firstSpanElement = paginationNav.querySelector("span");
        const firstDivElement =
          paginationNav.querySelector("div:first-of-type");

        // Select the elements for the right group (second span and last div)
        const secondSpanElement = paginationNav.querySelector(
          "span:nth-of-type(2)"
        );
        const lastDivElement = paginationNav.querySelector("div:last-of-type");

        // Create a div for the left group
        const leftGroup = document.createElement("div");
        leftGroup.classList.add("left-group"); // Add custom class
        leftGroup.style.display = "flex"; // Apply flex display
        leftGroup.style.alignItems = "center"; // Ensure alignment

        // Create a div for the right group
        const rightGroup = document.createElement("div");
        rightGroup.classList.add("right-group"); // Add custom class
        rightGroup.style.display = "flex"; // Apply flex display
        rightGroup.style.alignItems = "center"; // Ensure alignment
        rightGroup.style.marginLeft = "auto"; // Push to the right side

        // Append the first span and first div into the left group
        if (firstSpanElement && firstDivElement) {
          leftGroup.appendChild(firstSpanElement);
          leftGroup.appendChild(firstDivElement);
        }

        // Append the second span and last div into the right group
        if (secondSpanElement && lastDivElement) {
          rightGroup.appendChild(secondSpanElement);
          rightGroup.appendChild(lastDivElement);
        }

        // Prepend the left group to the pagination nav
        paginationNav.prepend(leftGroup);

        // Check if rightGroup has any children before appending it
        if (rightGroup.childElementCount > 0) {
          paginationNav.appendChild(rightGroup);
        }
      }
    }
  }, [callConferencingData]);
  return (
    <div className="dashboardWrp">
      <div className="uk-container uk-container-large">
        <div className="dashboardTop">
          <div uk-grid="" className="uk-grid uk-grid-small">
            <div className="uk-width-2-3">
              <div className="dashboardIntro">
                <h3>VPBX MANAGER</h3>
                {auth.role === "2" && (
                  <p>
                    Use this page to create new call routing, forward calls, set
                    up conference calls, manage existing extensions, and much
                    more.
                  </p>
                )}
              </div>
            </div>
            <div className="uk-width-1-1 ">
              <ul
                className="uk-subnav callSwitcher"
                id="renderSwitcher"
                uk-switcher="connect: .callClass"
              >
                {(auth.role === "2" || auth.role === "3") && (
                  <>
                    {auth.role === "2" || checkPermissions("ivr-flow") ? (
                      <li
                        onClick={() => navigate("/ivr-flow", { replace: true })}
                      >
                        <a href="#">IVR flow</a>
                      </li>
                    ) : null}
                    {auth.role === "2" || checkPermissions("extensions") ? (
                      <li
                        onClick={() =>
                          navigate("/extensions", { replace: true })
                        }
                      >
                        <a href="#">Extensions</a>
                      </li>
                    ) : null}
                    {auth.role === "2" || checkPermissions("Forwarding") ? (
                      <li
                        onClick={() =>
                          navigate("/call-forwarding", { replace: true })
                        }
                      >
                        <a href="#">Forwarding</a>
                      </li>
                    ) : null}
                    {auth.role === "2" || checkPermissions("conferencing") ? (
                      <li
                        className="uk-active"
                        onClick={() =>
                          navigate("/call-conferencing", { replace: true })
                        }
                      >
                        <a href="#">Conferencing</a>
                      </li>
                    ) : null}
                    {auth.role === "2" || checkPermissions("list-manager") ? (
                      <li
                        onClick={() =>
                          navigate("/list-manager", { replace: true })
                        }
                      >
                        <a href="#">List manager</a>
                      </li>
                    ) : null}
                    {auth.role === "2" || checkPermissions("sound-settings") ? (
                      <li
                        onClick={() =>
                          navigate("/sound-setting", { replace: true })
                        }
                      >
                        <a href="#">Sound settings</a>
                      </li>
                    ) : null}
                    {auth.role === "2" || checkPermissions("hours") ? (
                      <li onClick={() => navigate("/hour", { replace: true })}>
                        <a href="#">Hours</a>
                      </li>
                    ) : null}
                    {auth.role === "2" || checkPermissions("customized-ivr") ? (
                      <li
                        onClick={() =>
                          navigate("/customized-ivr", { replace: true })
                        }
                      >
                        <a href="#">Customized IVR</a>
                      </li>
                    ) : null}
                    {auth.role === "2" || checkPermissions("queue") ? (
                      <li onClick={() => navigate("/queue", { replace: true })}>
                        <a href="#">Queue</a>
                      </li>
                    ) : null}
                    {auth.role === "2" ? (
                      <li
                        onClick={() => navigate("/prompt", { replace: true })}
                      >
                        <a href="#">prompt</a>
                      </li>
                    ) : null}
                  </>
                )}
              </ul>
            </div>
          </div>
          <ul className="uk-switcher uk-margin callClass">
            {(auth.role === "2" || auth.role === "3") && (
              <>
                {auth.role === "2" || checkPermissions("ivr-flow") ? (
                  <li onClick={() => navigate("/ivr-flow")}></li>
                ) : null}

                {auth.role === "2" || checkPermissions("extensions") ? (
                  <li></li>
                ) : null}

                {auth.role === "2" || checkPermissions("Forwarding") ? (
                  <li></li>
                ) : null}

                {auth.role === "2" || checkPermissions("conferencing") ? (
                  <li>
                    <div className="ImcomingCallMain RoutingMain">
                      <div className="uk-grid" uk-grid="">
                        <div className="uk-width-1-2">
                          <div className="uk-text-left">
                            <div className="MainHeading">
                              <h6>Call conferencing</h6>
                            </div>
                          </div>
                        </div>

                        <div className="uk-width-1-2">
                          <div className="uk-text-right">
                            <span>
                              {(auth.role === "2" ||
                                (auth.role === "3" &&
                                  checkIndividualPermission(
                                    "conferencing",
                                    "read_and_write"
                                  ))) && (
                                <div className="uk-inline uk-text-left">
                                  <Link
                                    className="exportData-button NewFlow"
                                    to={
                                      auth.role === "3"
                                        ? "/new-call-conferencings"
                                        : "/new-call-conferencing"
                                    }
                                  >
                                    New conferencing
                                  </Link>
                                  {/* <button
                  className="exportData-button"
                  onClick={handleExportData}
                >
                  Export Data
                </button> */}
                                </div>
                              )}
                            </span>
                            <span className="primary-color"></span>
                          </div>
                        </div>
                      </div>
                      <div>
                        {loader ? (
                          <div uk-spinner="" className="tableloader"></div>
                        ) : (
                          <DataTable
                            columns={columns}
                            data={filteredDataCallConferencing}
                            pagination
                            customStyles={customStyles}
                          />
                        )}
                      </div>
                    </div>
                  </li>
                ) : null}
                {auth.role === "2" || checkPermissions("list-manager") ? (
                  <li></li>
                ) : null}

                {auth.role === "2" || checkPermissions("sound-settings") ? (
                  <li></li>
                ) : null}

                {auth.role === "2" || checkPermissions("hours") ? (
                  <li></li>
                ) : null}

                {auth.role === "2" || checkPermissions("customized-ivr") ? (
                  <li></li>
                ) : null}

                {auth.role === "2" || checkPermissions("queue") ? (
                  <li></li>
                ) : null}
                {auth.role === "2" ? <li></li> : null}
              </>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default CallConferencing;
